import { render, staticRenderFns } from "./StudyTimeline.vue?vue&type=template&id=6889f6d3&"
import script from "./StudyTimeline.vue?vue&type=script&lang=js&"
export * from "./StudyTimeline.vue?vue&type=script&lang=js&"
import style0 from "./StudyTimeline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports